import React from "react";
import Container from "../utils/Container";
import classes from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={classes.footerContainer}>
      <Container
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1rem",
        }}
      >
        <div>
          <h2>Contacts</h2>
        </div>
        <div>
          <h2>Links</h2>
        </div>
        <div>
          <h2>Info</h2>
        </div>
      </Container>
    </footer>
  );
}
